import * as prefs from '../../constants/preferences';
import {
  VERTICAL,
  HORIZONTAL,
  PANE_QUIZ_SIZE_DEFAULT,
  PANE_WORKSHEET_SIZE_DEFAULT,
} from '../../constants/common';

export const defaultState = {
  [prefs.AUTO_SAVE]: true,
  [prefs.DOCK_POSITION]: 'left',
  [prefs.UNITY_MODE]: 'plugin',

  [prefs.PANE_QUIZ_ORIENTATION]: VERTICAL,
  [prefs.PANE_QUIZ_SIZE]: PANE_QUIZ_SIZE_DEFAULT,
  [prefs.PANE_WORKSHEET_ORIENTATION]: HORIZONTAL,
  [prefs.PANE_WORKSHEET_SIZE]: PANE_WORKSHEET_SIZE_DEFAULT,
};

const preferences = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_PREFERENCE':
      let pref = {};
      pref[action.preference] = action.value;
      return { ...state, ...pref };
    case 'LOAD_PREFERENCES':
      return { ...defaultState, ...action.preferences };
    case 'RESET_PREFERENCES':
      return defaultState;
    default:
      return state;
  }
};

export default preferences;
